export enum ConversationNodesSummaryFormats {
  Full = 'full',
  Graph = 'graph',
}

export type ConversationNodeQuery = {
  projectId: number;
  startdate: string;
  enddate?: string;
  session?: string;
  format?: ConversationNodesSummaryFormats;
  focusedName?: string;
};

export type ConversationNodesSummaryMetadata = {
  organizationId?: string | number;
  startDate: string;
  endDate: string;
  sessionId?: string;
  projectId?: number;
};

export type ConversationNodeData = {
  name: string;
  value: number;
  exitValue: number;
  entryValue: number;
  category?: string;
  isFocused?: boolean;
};

export type ConversationNodeLink = {
  source: string;
  target: string;
  value: number;
};

export type ConversationNodesSummaryGraph = ConversationNodesSummaryMetadata & {
  data: ConversationNodeData[];
  links: ConversationNodeLink[];
};
